var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
export var ReactIntlErrorCode;
(function (ReactIntlErrorCode) {
  ReactIntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
  ReactIntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
  ReactIntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
  ReactIntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
  ReactIntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})(ReactIntlErrorCode || (ReactIntlErrorCode = {}));
var ReactIntlError = /** @class */function (_super) {
  __extends(ReactIntlError, _super);
  function ReactIntlError(code, message, exception) {
    var _this = _super.call(this, "[React Intl Error " + code + "] " + message + " \n" + (exception ? "\n" + exception.message + "\n" + exception.stack : '')) || this;
    _this.code = code;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(_this, ReactIntlError);
    }
    return _this;
  }
  return ReactIntlError;
}(Error);
export { ReactIntlError };
var UnsupportedFormatterError = /** @class */function (_super) {
  __extends(UnsupportedFormatterError, _super);
  function UnsupportedFormatterError(message, exception) {
    return _super.call(this, "UNSUPPORTED_FORMATTER" /* UNSUPPORTED_FORMATTER */, message, exception) || this;
  }
  return UnsupportedFormatterError;
}(ReactIntlError);
export { UnsupportedFormatterError };
var InvalidConfigError = /** @class */function (_super) {
  __extends(InvalidConfigError, _super);
  function InvalidConfigError(message, exception) {
    return _super.call(this, "INVALID_CONFIG" /* INVALID_CONFIG */, message, exception) || this;
  }
  return InvalidConfigError;
}(ReactIntlError);
export { InvalidConfigError };
var MissingDataError = /** @class */function (_super) {
  __extends(MissingDataError, _super);
  function MissingDataError(message, exception) {
    return _super.call(this, "MISSING_DATA" /* MISSING_DATA */, message, exception) || this;
  }
  return MissingDataError;
}(ReactIntlError);
export { MissingDataError };
var MessageFormatError = /** @class */function (_super) {
  __extends(MessageFormatError, _super);
  function MessageFormatError(message, locale, descriptor, exception) {
    var _this = _super.call(this, "FORMAT_ERROR" /* FORMAT_ERROR */, message + " \nLocale: " + locale + "\nMessageID: " + (descriptor === null || descriptor === void 0 ? void 0 : descriptor.id) + "\nDefault Message: " + (descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage) + "\nDescription: " + (descriptor === null || descriptor === void 0 ? void 0 : descriptor.description) + " \n", exception) || this;
    _this.descriptor = descriptor;
    return _this;
  }
  return MessageFormatError;
}(ReactIntlError);
export { MessageFormatError };
var MissingTranslationError = /** @class */function (_super) {
  __extends(MissingTranslationError, _super);
  function MissingTranslationError(descriptor, locale) {
    var _this = _super.call(this, "MISSING_TRANSLATION" /* MISSING_TRANSLATION */, "Missing message: \"" + descriptor.id + "\" for locale \"" + locale + "\", using " + (descriptor.defaultMessage ? 'default message' : 'id') + " as fallback.") || this;
    _this.descriptor = descriptor;
    return _this;
  }
  return MissingTranslationError;
}(ReactIntlError);
export { MissingTranslationError };